/*
 *
 * Wallets actions
 *
 */

import {
  ADD_MONEY_TO_WALLET,
  CREATE_WALLET,
  DEFAULT_ACTION,
  DISABLE_LOADER,
  ENABLE_LOADER,
  GET_WALLET_BALANCE,
  GET_WALLET_STATUS,
  MODIFY_WALLET_STATUS,
  UPDATE_BANK_DETAILS,
  UPDATE_DISPUTE_WALLET_BANK_DETAILS,
  UPDATE_DISPUTE_WALLET_STATUS,
  UPDATE_FEE_WALLET_DETAILS,
  UPDATE_WALLET_BALANCE,
  UPDATE_WALLET_STATUS,
} from './constants';

interface UpdateWalletsActionDataTypes {
  createdBy: string;
  name: string;
  refId: string;
  status: string;
  walletId: number;
  rechargeMode: { vba: string; ifsc: string };
}

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function getWalletStatusAction(data: {
  walletType: string;
  cb: Function;
  errorCb: Function;
}) {
  return {
    type: GET_WALLET_STATUS,
    data,
  };
}

export function updateWalletStatusAction(data: UpdateWalletsActionDataTypes) {
  return {
    type: UPDATE_WALLET_STATUS,
    data,
  };
}

export function getWalletBalanceAction(data: { cb: () => void }) {
  return {
    type: GET_WALLET_BALANCE,
    data,
  };
}

export function updateWalletBalanceAction(data: { balance: string }) {
  return {
    type: UPDATE_WALLET_BALANCE,
    data,
  };
}

export function addMoneyToWalletAction(data: { walletType: string }) {
  return {
    type: ADD_MONEY_TO_WALLET,
    data,
  };
}

export function modifyWalletStatusAction(data: {
  updatedBy: string;
  name: string;
  status: string;
}) {
  return {
    type: MODIFY_WALLET_STATUS,
    data,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function createWalletAction(data: { createdBy: string; name: string }) {
  return {
    type: CREATE_WALLET,
    data,
  };
}

export function updateBankDetailsAction(data: { ifsc: string; vba: string }) {
  return {
    type: UPDATE_BANK_DETAILS,
    data,
  };
}

export function updateFeeWalletDetailsAction(data: {
  status: string;
  balance: string;
}) {
  return {
    type: UPDATE_FEE_WALLET_DETAILS,
    data,
  };
}

export function updateDisputeWalletsAction(data) {
  return {
    type: UPDATE_DISPUTE_WALLET_STATUS,
    data,
  };
}

export function updateDisputeWalletsBankDetailsAction(data) {
  return {
    type: UPDATE_DISPUTE_WALLET_BANK_DETAILS,
    data,
  };
}
